"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchType = void 0;
var SearchType;
(function (SearchType) {
    SearchType["TypeAndEnter"] = "Type & enter";
    SearchType["MatchingSearchList"] = "Matching search list";
    SearchType["MatchingSearchExperience"] = "Matching search experience";
    SearchType["HistoryClick"] = "History click";
    SearchType["TrendingSearches"] = "Trending searches";
    SearchType["PopularExperiences"] = "Popular experiences";
    SearchType["PopularCategories"] = "Popular categories";
    SearchType["LastSeenExperiences"] = "Last seen experiences";
})(SearchType || (exports.SearchType = SearchType = {}));
//# sourceMappingURL=SearchType.js.map